import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import {
  gdkRequestNoPartnerCenterAccountMessage,
  goToPartnerCenter,
  signUpToIdXbox,
} from "../gdkMiddlewarePageContent";

export const NoPartnerCenterAccountStep = () => (
  <>
    <p>{gdkRequestNoPartnerCenterAccountMessage}</p>
    <Row>
      <Column>
        <a href="https://partner.microsoft.com/" target="_blank" rel="noreferrer">
          {goToPartnerCenter}
        </a>
      </Column>
      <Column>
        <a href="/games/partner">{signUpToIdXbox}</a>
      </Column>
      <Column />
      <Column />
    </Row>
  </>
);
